import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import mixins from "./mixins.js";

import "./assets/tailwind.css";
import "@fontsource/poppins/400.css";
import Vue3Toastify from "vue3-toastify";
import "vue3-toastify/dist/index.css";

// Create the app instance
const app = createApp(App);
const pinia = createPinia();

// Use plugins and configurations
app.use(store);
app.use(router);
app.use(pinia);
app.use(Vue3Toastify, {
  autoClose: 3000,
  position: "top-right",
});
app.mixin(mixins);

// Mount the app
app.mount("#app");
